import { MprcRequestErrorDialog, MprcRequestIndicator } from "components";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { UserInfoDto } from "generated/CoreApi_v1";
import { enqueueSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BatchEditSelectedUsers } from "views/foundation/user/components/BatchEdit/BatchEditSelectedUsers";
import { useUserBatchEditContext } from "views/foundation/user/Home/BatchEdit";
import { OPERATION_PAGE_SIZE } from "views/lms/enrollment/Home";

////////////////////////////////////////////////////////////////////////////

export const OperationSelectedUsers: React.FC = () => {

  const ctx = useUserBatchEditContext();
  const { t } = useTranslation();
  const api = useCoreApi();

  const [viewError, setViewError] = useState<any>();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  const [saving, setSaving] = useState<boolean>(false);

  ///
  const handleDelete = (item: UserInfoDto) => {
    setSaving(true);
    api.v1.userOperation.removeUser({
      operation: ctx.operation!,
      userIds: [item.userId]
    }).then(result => {
      if (result.data) getData();
      else enqueueSnackbar(t("User.BatchEdit.OperationFailMessage"), { variant: "error" });
    }).catch(e => {
      MprcRequestSnackbarErrorReport(e);
    }).finally(() => setSaving(false));
  };

  ///
  const clearAll = () => {
    setSaving(true);
    api.v1.userOperation.clearUsers({
      operation: ctx.operation!
    }).then(result => {
      if (result.data) getData(1);
      else enqueueSnackbar(t("User.BatchEdit.OperationFailMessage"), { variant: "error" });
    }).catch(e => {
      MprcRequestSnackbarErrorReport(e);
    }).finally(() => setSaving(false));
  };

  ///
  const getData = (pg?: number) => {
    setLoading(true);
    api.v1.userOperation.getSelectedUsers({
      operation: ctx.operation!,
      allActiveUsers: false,
      pageNumber: pg ?? pageNumber,
      pageSize: OPERATION_PAGE_SIZE
    })
      .then(response => {
        ctx.setSelectedUsers(response.data);
      })
      .catch(e => {
        ctx.setSelectedUsers(undefined);
        setViewError(e);
      })
      .finally(() => {
        setLoading(false);
        ctx.setReloadSelectedUsers(false);
      });
  };

  ////////////////////////////////////////////////////////////////////////////
  /// EFFECT'S
  ////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    if (ctx.reloadSelectedUsers) {
      getData(1);
    }
  }, [ctx.reloadSelectedUsers]);

  useEffect(() => {
    getData(pageNumber);
  }, [pageNumber]);

  ////////////////////////////////////////////////////////////////////////////
  /// RENDER
  ////////////////////////////////////////////////////////////////////////////

  return (
    <>
      <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(null)} />
      <MprcRequestIndicator visible={loading || saving} type={saving ? "post" : "request"} />

      <BatchEditSelectedUsers
        onClearAll={clearAll}
        onDeleteUser={handleDelete}
        onChangePage={page => setPageNumber(page)}
        onReload={() => setPageNumber(1)}
        viewData={ctx.selectedUsers}
      />
    </>
  );
};
